import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';
import * as popups from "../../constants/popup-types";


class NewVehicleLead extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'newVehicleLead';
        this.Config   = new AppConfig();
        this.payload  = null;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.payload = payload;
        this.call(this.Config.api.requests.newVehicleLead, payload);
    }

    // custom on failure
    onFailure(response, methodName = ''){
        this.dispatch(Actions.SetCarLeadServerError(response.err));

    }

    //Parse successful response
    onSuccess() {
        this.updateState();

    }

    //Dispatch actions to update redux state
    updateState() {
        //if the update succeeded, fetch the updated data
        const id = this.payload.expert_id ? this.payload.expert_id : this.payload.ad_id;
        this.dispatch(Actions.setVehicleAdsOnSuccess(id));

    }


}


export default NewVehicleLead;